module.exports = __webpack_public_path__ + "static/media/qdt.3db1271.wav";


//////////////////
// WEBPACK FOOTER
// ./src/static/voice/qdt.wav
// module id = TP4j
// module chunks = 1